import { QueueRes } from '@ijoin/hooks';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Alert, Stack } from '@mui/material';

type Props = {
  queue: QueueRes;
};

export const QueueTuningHints = ({ queue }: Props) => {
  const hints = queue.tuningHints ?? [];

  if (!hints.length) return null;

  return (
    <Stack spacing={1}>
      {hints.map(hint => (
        <Alert
          icon={
            hint.severity === 'warning' ? (
              <WarningAmberIcon fontSize='inherit' />
            ) : (
              <InfoOutlinedIcon fontSize='inherit' />
            )
          }
          key={hint.code}
          severity={hint.severity}
          variant='outlined'>
          {hint.message}
        </Alert>
      ))}
    </Stack>
  );
};
